import $ from 'jquery';
import { getState } from '~src/state';
import { loadExportSettings } from '~core/grigliaProvino/exportSettingsStorage';
import { getProvinoFormats } from '~core/grigliaProvino/provinoFormats';
import { canUseTaglierinaMementoSantini } from '~core/grigliaProvino/taglierinaMementoSantiniAccess';

export const addProvinoFormatsToExportMenu = () => {
  const projectType = getState('selected.tipo');
  $('#export-selector-provino-formats').hide();
  $('#provino-preview-col').hide();

  const formatiProvino = getProvinoFormats({
    canUseTaglierinaMemento: canUseTaglierinaMementoSantini(),
  });

  const formatOption = (option) => {
    if (!option.id) {
      return option.text;
    }
    const $option = $('<div class="provino-format-option"></div>');
    $option.append(
      $('<div class="provino-format-title"></div>').text(option.text)
    );
    if (option.caption) {
      $option.append(
        $('<div class="provino-format-caption"></div>').text(option.caption)
      );
    }
    return $option;
  };

  const formatSelection = (option) => {
    if (option.caption) {
      return option.text + ' - ' + option.caption;
    }
    return option.text;
  };

  if (projectType.griglia_provino === true) {
    const savedSettings = loadExportSettings();
    const savedFormatExists =
      !!savedSettings?.formatId &&
      formatiProvino.some((f) => f.id === savedSettings.formatId);

    $('#navbar-submenu-export-provino-output').select2({
      data: formatiProvino,
      tags: false,
      width: '100%',
      theme: 'bootstrap4',
      placeholder: 'Seleziona un formato',
      templateResult: formatOption,
      templateSelection: formatSelection,
    });

    if (savedFormatExists) {
      $('#navbar-submenu-export-provino-output')
        .val(savedSettings.formatId)
        .trigger('change');
    }

    if (savedSettings) {
      if (typeof savedSettings.outerPadding === 'boolean') {
        $('#outer-provino-grid-padding').bootstrapToggle(
          savedSettings.outerPadding ? 'on' : 'off'
        );
      }
      if (typeof savedSettings.innerPadding === 'boolean') {
        $('#inner-provino-grid-padding').bootstrapToggle(
          savedSettings.innerPadding ? 'on' : 'off'
        );
      }
    }

    $('#export-selector-provino-formats').show();
    $('#provino-preview-col').show();
    $('#navbar-submenu-export').addClass('navbar-submenu-two-columns');
    $('#export').text('Scarica Pagine Selezionate');
  } else {
    $('#export-selector-provino-formats').hide();
    $('#provino-preview-col').hide();
  }
};
